































































































































import Vue from 'vue';
import Component from 'vue-class-component';

// Store types
import {
    FooterFloatingAction,
    FooterInfo,
    FooterNext,
    RequestGetter,
} from '@/store/store.types';

// Used for the loading error
import InfoModal from '@/components/modal/Info.vue';

/**
 *  The footer of the tool.
 */
@Component
export default class Footer extends Vue {

    public $refs!: {
        infoModal: InfoModal;
    };

    /**
     *  Used to get the floating action from the store
     */
    private get floatingAction(): FooterFloatingAction | null {

        return this.$store.state.footer.floatingAction;

    }

    /**
     *  Used to get the total price of the request to show in the footer.
     */
    private get totalPrice(): number {

        return this.$store.getters[RequestGetter.PRICE_TOTAL];

    }

    /**
     *  Used to get the info from the store.
     */
    private get info(): FooterInfo | null {

        return this.$store.state.footer.info;

    }

    /**
     *  Used to get the settings of the next button from the store.
     */
    private get next(): FooterNext | null {

        return this.$store.state.footer.next;

    }

    /**
     *  Used to get the title of the next button.
     */
    private get nextTitle(): string | null {

        if (!this.next) {

            return null;

        }

        if (this.next.title) {

            return this.next.title;

        }

        if (this.next.step) {

            return this.next.step.title;

        }

        return null;

    }

    /**
     *  Used to get the content of the next button.
     */
    private get nextContent(): string | null {

        if (!this.next) {

            return null;

        }

        if (this.next.content) {

            return this.next.content;

        }

        if (this.next.step) {

            return `
                <span class="next__label">
                    ${ this.next.step.label }
                </span>
                <span class="next__action">
                    ${ this.next.step.action }
                </span>
            `;

        }

        return null;

    }

    /**
     *
     *  Used to get the fact if there's a next step.
     *
     *  (i) Hiding the next arrow if not
     *
     */
    private get nextStep(): boolean {

        if (!this.next) {

            return false;

        }

        return this.next.step !== undefined;

    }

    /**
     *  Used to open the info modal on smaller screens, using the
     *  info's default content as body for the modal.
     */
    private openInfo(): void {

        if (!this.info) {

            return;

        }

        void this.$refs.infoModal.open({
            body: this.info.content,
            confirm: {
                title: 'Sluiten',
                content: 'Sluiten',
            },
        });

    }

}
